@if (order && order.status=='Paid') {
  <div>
    <div class="py-5 text-center">
      @switch (order?.organizationName?.toLowerCase()) {
        @case ('flygets') {
          <img class="d-block margin" src="../../../../../assets/img/thumbnail_Flygets-logo.png" />
        }
        @case ('skavsta') {
          <img class="d-block d-block-skavsta margin" src="../../../../../assets/img/skavsta-logo.png" />
        }
        @case ('nazar') {
          <img class="d-block margin" src="../../../../../assets/img/nasar_logo.png" />
        }
        @case ('tui') {
          <img class="d-block margin" src="../../../../../assets/img/SE_TUI_3CPM_transparent_blue_Co_coop.png" />
        }
        @case ('quality hotel arlanda xpo') {
          <img class="d-block d-block-quality margin" src="../../../../../assets/img/quality-hotel-airport-arlanda.svg" />
        }
        @case ('apartdirect') {
          <img class="d-block d-block-scandic margin" src="../../../../../assets/img/apartdirect.jpg" />
        }
        @case ('scandic hotel') {
          <img class="d-block d-block-scandic margin" src="../../../../../assets/img/Scandic_logo.svg" />
        }
        @case ('aiden hotel') {
          <img class="d-block d-block-aiden margin" src="../../../../../assets/img/Aiden-hotel-logo.svg" />
        }
        @default {
          <img class="d-block d-block-parkifly margin" src="../../../../../assets/img/ParkiFly-logo.svg" />
        }
      }
      <h2>Tack för din bokning!</h2>
      <p class="lead">En bokningsbekräftelse kommer skickas till din mail. Om du inte hittar den i inkorgen, titta i din
      skräpkorg. Ibland hamnar bekräftelsen där.</p>
      <p class="font-weight-light">Varmt välkomna!</p>
    </div>
    <mat-card appearance="outlined" class="example-card mat-elevation-z8">
      <mat-card-header>
        <mat-card-title>Ordernummer: {{order.orderNr}}</mat-card-title>
        <mat-card-subtitle>Datum: {{order.orderDate | date: 'yyyy-MM-dd'}}</mat-card-subtitle>
      </mat-card-header>
      @if (order.organizationName != 'Scandic Hotel' && order.organizationName != 'ApartDirect') {
        <mat-card-header>
          <mat-card-title>Personuppgifter</mat-card-title>
          <mat-card-subtitle>{{order.customer.firstName}} {{order.customer.lastName}}</mat-card-subtitle>
          <mat-card-subtitle>{{order.customer.email}}</mat-card-subtitle>
          <mat-card-subtitle>{{order.customer.cellular}}</mat-card-subtitle>
        </mat-card-header>
      }
      <div class="row">
        @if (parkingOrder && parkingOrder.length > 0) {
          <div class="col">
            <mat-card-header>
              <mat-card-title>Parkering</mat-card-title>
              <mat-card-subtitle>Från: {{parkingOrder[0].parkingFrom | date: 'yyyy-MM-dd HH:mm' }}</mat-card-subtitle>
              <mat-card-subtitle>Till: {{parkingOrder[0].parkingTo | date: 'yyyy-MM-dd HH:mm'}}</mat-card-subtitle>
              <mat-card-subtitle>Registreringsnummer: {{parkingOrder[0].carId}}</mat-card-subtitle>
              <!-- <mat-card-subtitle>Parkeringsplats: {{parkingOrder[0].parkingSiteName}}</mat-card-subtitle> -->
            </mat-card-header>
          </div>
        }
      </div>
      @if (shuttleOrders && shuttleOrders.length > 0) {
        <div>
          <div class="row">
            <div class="col">
              <mat-card-header>
                <mat-card-title>Transfer</mat-card-title>
                @for (shuttle of shuttleOrders; track shuttle) {
                  <mat-card-subtitle>{{shuttle.shuttleTypeName}} {{shuttle.shuttleDate |
                  date: 'yyyy-MM-dd HH:mm'}}</mat-card-subtitle>
                }
              </mat-card-header>
            </div>
          </div>
        </div>
      }
      <mat-divider></mat-divider>
      @if (order.totalDiscountPriceIncVat > 0) {
        <mat-card-content>
          @if (!order.amountDiscount) {
            <div class="mt-3">
              <p class="font-weight-light mt-4">Pris: {{order.totalPriceIncVat | number : '1.2-2'}} SEK (Varav moms:
              {{order.totalVat | number : '1.2-2'}} SEK)</p>
            </div>
          }
          @if (order.amountDiscount) {
            <div class="mt-3">
              <p class="font-weight-light mt-4">Ordinarie pris: {{order.totalPriceIncVat | number : '1.2-2'}} SEK (Varav moms:
              {{order.totalVat | number : '1.2-2'}} SEK)</p>
              <p class="font-weight-light mt-4">Rabatt: {{order.totalPriceIncVat - order.totalDiscountPriceIncVat | number :
              '1.2-2'}} SEK</p>
              <p class="font-weight-light mt-4">Rabaterat pris: {{order.totalDiscountPriceIncVat | number : '1.2-2'}} SEK
              (Varav moms: {{order.vatAmountDiscount | number : '1.2-2'}} SEK)</p>
            </div>
          }
          <mat-toolbar>
            <span>Totalt</span>
            <span class="spacer"></span>
            @if (!order.amountDiscount) {
              <span>{{order.totalPriceIncVat | number : '1.2-2'}} SEK</span>
            }
            @if (order.amountDiscount) {
              <span>{{order.totalDiscountPriceIncVat | number : '1.2-2'}} SEK</span>
            }
          </mat-toolbar>
        </mat-card-content>
      }
      <mat-card-actions>
        <button mat-raised-button color="primary" class="width-100-mt-12"
        (click)="goToWhenDone()">KLAR</button>
      </mat-card-actions>
    </mat-card>
  </div>
}

@if (order && order.status=='Checkout') {
  <div>
    <app-payment-failure [order]="order"></app-payment-failure>
  </div>
}

@if (order && order.status=='Cancelled') {
  <div>
    <div class="py-5 text-center">
      <img class="d-block mx-auto mb-4" src="../../../assets/img/thumbnail_Flygets-logo.png" alt="Flygets logo-retina"
        height="72">
      <h2>Den här bokningen är cancellerad</h2>
      <p class="lead">Vill du göra en ny bokning?</p>
      <button mat-raised-button color="primary" (click)="goToWhenDone()">Tillbaka till bokningen</button>
    </div>
  </div>
}